import {
  ElNotification,
  // ElMessage
} from 'element-plus';
import {
  errorMsg,
  // warningMsg
} from '@/utils/message';
import { i18n } from '@/Lang/index';

export function errorNotify(res) {
  /*
  if (res.status === -1) {
    if (router.history.current.path !== '/login') {
      if (lastErr === undefined) {
        ElMessage({
          message: warningMsg.Login_timeout,
          type: 'error',
          duration: 5 * 1000,
          customClass: 'notify',
        });
        lastErr = -1;
        setTimeout(() => {
          lastErr = undefined;
        }, 3000);
      }

      store.dispatch('user/resetUser');
      destroySocket();

      router.push({
        path: '/',
      });

      return res;
    }
  } else */
  if (res.status === -9) {
    ElNotification({
      title: i18n.global.t('request.error'),
      message: res.data,
      type: 'error',
      duration: 2000,
      customClass: 'notify',
    });

    // console.log(res);
  } else if (res.status === -2 || res.status === -3 || res.status === -4) {
    let message = '';
    for (const msg of res.data) {
      if (errorMsg[msg.cause]) {
        message += errorMsg[msg.cause] + '\n';
      } else {
        message += msg.cause + '\n';
      }
    }
    message = message.substring(0, message.length - 1);

    ElNotification({
      title: i18n.global.t('request.error'),
      message: message,
      type: 'error',
      duration: 2000,
      customClass: 'notify',
    });

    // console.log('error:' + message);
  }
}
